import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import AuthCallback from './components/AuthCallback';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CraftingPage from './pages/CraftingPage';
import StorePage from './pages/StorePage';
import NewsPage from './pages/NewsPage';
import TermsPage from './pages/TermsPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import AccountPage from './pages/AccountPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DonatePage from './pages/DonatePage';
import SupportersPage from './pages/SupportersPage';
import { SapphireProvider } from './context/SapphireContext';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App scroll-smooth">
      <LanguageProvider>
      <AuthProvider>
        <SapphireProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster />
        </SapphireProvider>
      </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="crafting" element={<CraftingPage />} />
                <Route path="store" element={<StorePage />} />
                <Route path="news" element={<NewsPage />} />
                <Route path="account" element={<AccountPage />} />
                <Route path="account/reset" element={<ResetPasswordPage />} />
                <Route path="donate" element={<DonatePage />} />
                <Route path="supporters" element={<SupportersPage />} />
                <Route path="terms" element={<TermsPage />} />
                <Route path="delete-account" element={<DeleteAccountPage />} />
              </Route>
            </Routes>
  );
}

export default App;
